export default function SidebarShimmer() {
  return (
    <div className="h-screen w-full animate-pulse rounded">
      <div className="flex h-screen w-full flex-col space-y-6 bg-card p-8"></div>
    </div>
  );
}
